import Vue from 'vue';

Vue.component( 'campo', () => import( '@com/shared/campo.vue' ) );
Vue.component( 'campo-vertical', () => import( '@com/shared/campo-vertical.vue' ) );
Vue.component( 'card-vertical', () => import( '@com/shared/card-vertical.vue' ) );
Vue.component( 'input-radio', () => import( '@com/shared/Radio.vue' ) );
Vue.component( 'input-select', () => import( '@com/shared/input-select.vue' ) );

Vue.component( 'titulo-seccion', () => import( '@com/shared/titulo-seccion.vue' ) );
Vue.component( 'titulo-seccion-icono', () => import( '@com/shared/titulo-seccion-icono.vue' ) );
Vue.component( 'subtitulo-seccion-icono', () => import( '@com/shared/subtitulo-seccion-icono.vue' ) );

Vue.component( 'a-menu', () => import( '@com/a-interfaz/a-menu.vue' ) );
Vue.component( 'a-toolbar', () => import( '@com/a-interfaz/a-toolbar.vue' ) );
Vue.component( 'a-inicio', () => import( '@com/a-interfaz/a-inicio.vue' ) );
Vue.component( 'a-contenido', () => import( '@com/a-interfaz/a-contenido.vue' ) );
Vue.component( 'contenido', () => import( '@com/a-interfaz/contenido.vue' ) );
